import { useMemo } from "react";
import { useStore } from "react-redux";

const EdelmetallBezeichnung = (props) => {
  const { kennziffer, name } = props || {};
  const { metalsStorage } = useStore().getState();

  const item = useMemo(() => {
    return metalsStorage.all.find(m => Number(m.kennziffer) === Number(kennziffer)) || {};
  }, [kennziffer, metalsStorage.all]);

  return item.name || name || "";
};

export default EdelmetallBezeichnung;
